/* eslint-disable no-extra-parens */
import styled from 'styled-components'
import { DEVICE, BLOCK_MARGIN_TOP } from '../../util/constants'
import { Link } from 'gatsby'

export const RegionContainer = styled.div`
  display: grid;
  grid-template-columns: 32px 10fr 32px;

  @media ${DEVICE.tabletL} {
    grid-template-columns: 1fr 10fr 1fr;
    max-width: 1317px;
  }

  [data-layout='two-column'] & {
    @media ${DEVICE.laptopG} {
      grid-template-columns: 1fr;
    }
  }
`

export const GriddedContentBlock = styled(RegionContainer)`
  grid-template-columns: 32px repeat(10, 1fr) 32px;
  align-content: start;
  margin-top: ${BLOCK_MARGIN_TOP}px;
  /* padding-bottom: ${BLOCK_MARGIN_TOP}px; */
  padding-bottom: ${({ bottomPaddingAdjustment }) =>
    bottomPaddingAdjustment
      ? bottomPaddingAdjustment
      : `${BLOCK_MARGIN_TOP}px`};

  @media ${DEVICE.tabletL} {
    grid-template-columns: 1fr repeat(10, 1fr) 1fr;
  }
`

export const SocialIconRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 30px;
  width: 214px;
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : '13px')};
  padding-bottom: 60px;
`

// Utility Text Styles for common patterns

export const HeroH1 = styled.h1`
  /* Figma: H1 Mobile Light 36 */
  font-size: 3.6rem;
  line-height: 1.35;
  font-weight: 300;
  color: var(--highlight-blue);

  @media ${DEVICE.tabletL} {
    /* Figma: H1 Desktop Light 48 */
    font-size: 4.8rem;
  }

  @media ${DEVICE.laptopS} {
    /* Figma: H1 Desktop Light 64 */
    font-size: 6.4rem;
  }
`

export const HeroP = styled.p`
  /* Figma: H4 Mobile Regular 16 */
  font-style: normal;
  font-weight: normal;
  font-size: 1.6rem;
  line-height: 1.375;
  color: var(--content-background-dark-blue);

  /* Not defined in Figma */
  @media ${DEVICE.tabletL} {
    font-size: 2rem;
    line-height: 1.6;
  }

  /* Figma: H4 Desktop Regular 24 */
  @media ${DEVICE.desktop} {
    font-size: 2.4rem;
  }
`

export const Caption = styled.figcaption`
  font-style: normal;
  font-weight: bold;
  font-size: 1.4rem;
  line-height: 1.7;
  letter-spacing: 0.02rem;
  color: var(--highlight-blue);
`

export const NoResultsMessage = styled(HeroP)`
  grid-column: 2 / 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px 20% 0;
`

export const BackButtonContainer = styled(Link)`
  grid-column: 2 / 3;
  grid-row: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration-line: none;
  margin-top: 41px;

  svg {
    margin-right: 20px;
  }

  span {
    font-style: normal;
    font-weight: 600;
    font-size: 1.2rem;
    line-height: 1.357;
    text-transform: uppercase;
    color: var(--content-background-dark-blue);
  }

  @media ${DEVICE.tabletL} {
    span {
      font-size: 1.4rem;
    }
  }
`

export const BackButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration-line: none;
  outline: none;
  background: 0;

  svg {
    margin-right: 20px;
  }

  span {
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 1.2rem;
    line-height: 1.357;
    text-transform: uppercase;
    color: var(--content-background-dark-blue);
  }

  @media ${DEVICE.tabletL} {
    span {
      font-size: 1.4rem;
    }
  }
`
